(() => {
  angular.module('pims').filter('htmlEscapes', () => {
    'ngInject';
    return (text, action) => {
      if (!text) return text;
      switch (action) {
        case 'escape':
          return text
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
        
        case 'unescape':
          return text
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, "\"");
        
        default: 
          return text;
      }
    };
  });
})();